import { create } from 'zustand'
import { fetchOriginServerStatus, fetchD1RouteCount } from '../utils/api'

const useUserSceneStore = create((set, get) => ({
  // 状态
  userScene: null, // 'ESTABLISHED_USER', 'MIRROR_USER', 'NEW_USER'
  originServer: {
    hasContent: false,
    isLoading: false,
    error: null,
    contentLength: 0,
    is404: false
  },
  d1: {
    routeCount: 0,
    isLoading: false,
    error: null
  },
  isDetecting: false,
  forceLocked: false,
  lockedTarget: null,
  
  // 动作
  detectUserScene: async () => {
    set({ isDetecting: true })
    
    try {
      const [originStatus, routeCount] = await Promise.all([
        fetchOriginServerStatus(),
        fetchD1RouteCount()
      ])
      
      const contentLength = originStatus.contentLength || 0
      const is404 = originStatus.is404 || false
      
      set({
        originServer: {
          hasContent: originStatus.hasContent,
          isLoading: false,
          error: null,
          contentLength,
          is404
        },
        d1: {
          routeCount: routeCount || 0,
          isLoading: false,
          error: null
        },
        forceLocked: false,
        lockedTarget: null
      })
      
      const userScene = get().determineUserScene()
      set({ userScene, isDetecting: false })
      
      return userScene
    } catch (error) {
      set({
        originServer: {
          hasContent: false,
          isLoading: false,
          error: error.message,
          contentLength: 0,
          is404: false
        },
        d1: {
          routeCount: 0,
          isLoading: false,
          error: error.message
        },
        isDetecting: false,
        userScene: 'NEW_USER',
        forceLocked: false,
        lockedTarget: null
      })
      return 'NEW_USER'
    }
  },
  
  // 判定用户场景的函数
  determineUserScene: () => {
    const { d1, originServer } = get()
    
    if (d1.routeCount > 5) {
      return 'ESTABLISHED_USER' // 已有大量内容
    }
    
    if (originServer.hasContent) {
      return 'MIRROR_USER' // 有原站，待镜像
    }
    
    return 'NEW_USER' // 纯新站
  },
  
  // 手动设置用户场景（用于测试）
  setUserScene: (scene) => {
    set({ userScene: scene })
  },
  
  // 重置状态
  resetScene: () => {
    set({
      userScene: null,
      originServer: {
        hasContent: false,
        isLoading: false,
        error: null,
        contentLength: 0,
        is404: false
      },
      d1: {
        routeCount: 0,
        isLoading: false,
        error: null
      },
      forceLocked: false,
      lockedTarget: null
    })
  },
  
  unlockForce: () => {
    set({ forceLocked: false, lockedTarget: null })
  }
}))

export default useUserSceneStore
